import TableCell from '@mui/material/TableCell';
import { fontColorDarkTheme } from '../../../styles/global.styles';
import { Collapse } from '@mui/material';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { ReactNode } from 'react';

interface ExpandRowContentProps {
  isOpen: boolean;
  content: ReactNode;
  colSpan: number;
}

const ExpandRowContent = ({ isOpen, content, colSpan }: ExpandRowContentProps) => {
  return (
    <TableRow>
      <TableCell
        style={{
          border: isOpen ? '1px solid var(--app-table-border)' : 'none',
          color: fontColorDarkTheme,
          padding: isOpen ? undefined : 0,
        }}
        colSpan={colSpan}
      >
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          {content}
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default ExpandRowContent;
